/**
 * Phone / email helpers aligned with radiusApp Coversheet-New Sections/shared/utils.js
 */

export const formatPhoneNumber = (value) => {
  if (!value) return ""
  let numbers = String(value).replace(/\D/g, "")
  if (numbers.length === 11 && numbers.charAt(0) === "1") {
    numbers = numbers.slice(1)
  }
  const trimmed = numbers.slice(0, 10)
  if (trimmed.length >= 7) {
    return `${trimmed.slice(0, 3)}-${trimmed.slice(3, 6)}-${trimmed.slice(6)}`
  }
  if (trimmed.length >= 4) {
    return `${trimmed.slice(0, 3)}-${trimmed.slice(3)}`
  }
  return trimmed
}

/** Digits only, max 10, strips leading US country code 1 */
export const phoneDigits = (value) => {
  if (!value) return ""
  let d = String(value).replace(/\D/g, "")
  if (d.length === 11 && d.charAt(0) === "1") d = d.slice(1)
  return d.slice(0, 10)
}

export const emailErrorMessage = (value) => {
  const v = (value || "").trim()
  if (!v) return ""
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(v)) return "Please enter a valid email address"
  return ""
}

export const phoneErrorMessage = (value) => {
  const v = (value || "").trim()
  if (!v) return ""
  const onlyNums = phoneDigits(v)
  if (onlyNums.length !== 10) return "Phone number must be exactly 10 digits"
  return ""
}

export const defaultReferralContactErrors = () => ({
  referring: { email: "", phone: "" },
  representing: [{ email: "", phone: "" }],
  clients: [{ email: "", phone: "" }],
})

export const validateReferralContactRows = ({
  referring,
  representingAgents,
  clients,
}) => {
  const referringErr = {
    email: (referring.email || "").trim() ? emailErrorMessage(referring.email) : "",
    phone: (referring.phone || "").trim() ? phoneErrorMessage(referring.phone) : "",
  }
  const repErrs = representingAgents.map(a => ({
    email: (a.email || "").trim() ? emailErrorMessage(a.email) : "",
    phone: (a.phone || "").trim() ? phoneErrorMessage(a.phone) : "",
  }))
  const cliErrs = clients.map(c => ({
    email: (c.email || "").trim() ? emailErrorMessage(c.email) : "",
    phone: (c.phone || "").trim() ? phoneErrorMessage(c.phone) : "",
  }))
  const hasError = Boolean(
    referringErr.email
    || referringErr.phone
    || repErrs.some(e => e.email || e.phone)
    || cliErrs.some(e => e.email || e.phone),
  )
  return {
    hasError,
    errors: { referring: referringErr, representing: repErrs, clients: cliErrs },
  }
}

export const validateEscrowEmails = (escrows) => {
  return escrows.map((e) => {
    if (!(e.escrowEmail || "").trim()) return ""
    return emailErrorMessage(e.escrowEmail)
  })
}
